export default "__VITE_ASSET__Bger3uRn__"